
import type {
  BaseErrorResponse,
  CreateCurrencyRateReq,
  EmptySuccessResponse,
  GetCurrencyRateRes,
  GetCurrencyRatesRes,
  UpdateCurrencyRateReq,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useCurrencyRate() {
  class CurrencyRate<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Currency rate
     * @name CurrencyRateControllerGetAllCurrencyRates
     * @summary Getting all currency rates
     * @request GET:/api3/currency-rate
     * @secure
     * @response `200` `GetCurrencyRatesRes`
     * @response `400` `BaseErrorResponse`
     */
    currencyRateControllerGetAllCurrencyRates = (
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
        /** @example "EUR" */
        currency: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCurrencyRatesRes, BaseErrorResponse>({
        path: '/api3/currency-rate',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Currency rate
     * @name CurrencyRateControllerCreateCurrencyRate
     * @summary Creating a currency rate
     * @request POST:/api3/currency-rate
     * @secure
     * @response `200` `GetCurrencyRateRes`
     * @response `400` `BaseErrorResponse`
     */
    currencyRateControllerCreateCurrencyRate = (data: CreateCurrencyRateReq, params: RequestParams = {}) =>
      this.request<GetCurrencyRateRes, BaseErrorResponse>({
        path: '/api3/currency-rate',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Currency rate
     * @name CurrencyRateControllerUpdateCurrencyRate
     * @summary Updating a currency rate
     * @request PUT:/api3/currency-rate/{id}
     * @secure
     * @response `200` `GetCurrencyRateRes`
     * @response `400` `BaseErrorResponse`
     */
    currencyRateControllerUpdateCurrencyRate = (id: string, data: UpdateCurrencyRateReq, params: RequestParams = {}) =>
      this.request<GetCurrencyRateRes, BaseErrorResponse>({
        path: `/api3/currency-rate/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Currency rate
     * @name CurrencyRateControllerDeleteCurrencyRate
     * @summary Deleting a currency rate
     * @request DELETE:/api3/currency-rate/{id}
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    currencyRateControllerDeleteCurrencyRate = (id: string | number, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: `/api3/currency-rate/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new CurrencyRate();
}
